import { useEffect, useState } from 'react';
import {
  productionBetweenDaysGetApi,
  ProductionSimpleType,
} from '../../api/apiConfig';
import useFetch from '../../api/useFetch';
import { getMonthStartEnd } from '../../function/replaceString';
import styled from 'styled-components';

export const WeeklyProductionTable = () => {
  const [data, setData] = useState<ProductionSimpleType[]>([]);

  const { fetch: fetchProductionBetweenDaysGetApi } = useFetch({
    fetchFunction: productionBetweenDaysGetApi,
    onSuccess: (data: ProductionSimpleType[]) => {
      const testData = data.filter(
        (prod) => prod.prodDes === '미드미 봉대(빨)'
      );
      initData(data);
    },
  });

  function initData(data: ProductionSimpleType[]) {
    let groupedData: ProductionSimpleType[] = [];
    data.forEach((production) => {
      const targetGroup = groupedData.find(
        (group) => group.prodDes === production.prodDes
      );
      if (targetGroup) {
        targetGroup.qty += production.qty;
      } else {
        groupedData.push({ ...production });
        // groupedData.push(production);
      }
    });
    setData(groupedData);
  }

  useEffect(() => {
    const { start, end } = getMonthStartEnd(new Date());
    fetchProductionBetweenDaysGetApi({
      startDate: start,
      endDate: end,
    });
  }, []);
  return (
    <Container>
      {data.length > 0 ? (
        <>
          <Row>
            <div className='des'>품목명</div>
            <div className='qty'>생산수량</div>
          </Row>

          <BodyContainer>
            {data
              .filter((production) => production.qty > 0)
              .sort((a, b) => b.qty - a.qty)
              .map((production) => (
                <>
                  <BodyRow>
                    <div className='des'>{production.prodDes}</div>
                    <div className='qty'>{production.qty.toLocaleString()}</div>
                  </BodyRow>
                </>
              ))}
          </BodyContainer>
        </>
      ) : (
        <StyledH4>생산목록이 없습니다</StyledH4>
      )}
    </Container>
  );
};

const StyledH4 = styled.h4`
  margin: 0;
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 12px;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 29px;
  font-weight: 600;
  font-size: 12px;
  margin-top: 7px;

  .des {
    flex: 1 0 50%;
    text-align: start;
    padding-left: 15px;
    overflow: hidden; /* 넘치는 부분 숨김 */
    text-overflow: ellipsis; /* 가려지는 부분 ... 처리 */
    white-space: nowrap; /* 줄 넘김 금지 */
  }
  .qty {
    flex: 0 0 18%;
    text-align: center;
  }
`;

const BodyContainer = styled.div`
  height: 210px;
  /* background-color: #f0f0f0; */
  border-top: 1px solid #cccccc7d;
  border-bottom: 1px solid #cccccc7d;
  margin-top: 7px;
  overflow-y: scroll;
`;

const BodyRow = styled(Row)`
  border-bottom: 1px solid #cccccc7d;
  margin-top: 0px;
  font-weight: 500;
`;
